import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchMidpointMediaCrmSummary } from "../../../api/midpointMediaAdminApi";
import {
  ClientPortalError,
  ClientPortalLoading,
} from "../../../components/clientPortal/ClientPortalStates";
import useMidpointMediaAdminView from "../../../hooks/useMidpointMediaAdminView";
import "../../../styles/midpointMediaAdmin.css";

export default function MidpointMediaAdminCrmHubPage() {
  const { clientViewId, paths, viewBase } = useMidpointMediaAdminView();
  const [state, setState] = useState({ loading: true, error: "", summary: null });

  useEffect(() => {
    if (!clientViewId) return undefined;
    let cancelled = false;
    fetchMidpointMediaCrmSummary(clientViewId)
      .then((body) => {
        if (!cancelled) setState({ loading: false, error: "", summary: body.summary });
      })
      .catch((error) => {
        if (!cancelled) setState({ loading: false, error: error.message, summary: null });
      });
    return () => {
      cancelled = true;
    };
  }, [clientViewId]);

  if (!clientViewId) return <p className="empty-state">No workspace assigned.</p>;
  if (state.loading) return <ClientPortalLoading message="Loading CRM…" />;
  if (state.error) return <ClientPortalError message={state.error} />;

  const recent = state.summary?.leads?.recent || [];

  return (
    <div className="mm-admin-page">
      <header>
        <p className="mm-admin-kicker">CRM</p>
        <h1>Pipeline and relationships</h1>
        <p className="mm-admin-lead">
          Leads and opportunities for Midpoint Media — including Venezuela careers applications
          and consulting inquiries. This is the same CRM data as the platform workspace, scoped
          to this site.
        </p>
      </header>

      <section className="mm-admin-grid">
        <article className="mm-admin-card">
          <h3>Leads</h3>
          <div className="mm-admin-kpi">
            {state.summary?.leads?.total ?? 0}
            <span>Inbound records</span>
          </div>
          <Link to={`${paths.base}/crm/leads`}>Open leads</Link>
        </article>
        <article className="mm-admin-card">
          <h3>Opportunities</h3>
          <div className="mm-admin-kpi">
            {state.summary?.opportunities?.total ?? 0}
            <span>Converted pipeline</span>
          </div>
          {viewBase ? <Link to={`${viewBase}/opportunities`}>Open opportunities</Link> : null}
        </article>
        <article className="mm-admin-card">
          <h3>Activities</h3>
          <p className="mm-admin-lead">Follow-ups live on each opportunity record.</p>
          {viewBase ? <Link to={`${viewBase}/opportunities`}>Review follow-ups</Link> : null}
        </article>
        <article className="mm-admin-card">
          <h3>Reports</h3>
          <p className="mm-admin-lead">Export and filter the opportunity pipeline.</p>
          {viewBase ? <Link to={`${viewBase}/reports/opportunities`}>Opportunity report</Link> : null}
        </article>
      </section>

      <section className="mm-admin-card">
        <h2>Recent leads</h2>
        {recent.length ? (
          <table className="mm-admin-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Status</th>
                <th>Reference</th>
              </tr>
            </thead>
            <tbody>
              {recent.map((lead) => (
                <tr key={lead.id}>
                  <td>
                    <Link to={`${paths.base}/crm/leads/${lead.id}`}>{lead.name}</Link>
                    <div className="muted">{lead.email}</div>
                  </td>
                  <td>{lead.roleType || lead.leadType || "—"}</td>
                  <td>{lead.status}</td>
                  <td>{lead.referenceId || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="empty-state">No leads yet.</p>
        )}
      </section>
    </div>
  );
}
